module.exports = __webpack_public_path__ + "img/yy.9b13d3f9.png";